"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = exports.BadgeType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var BadgeType;
(function (BadgeType) {
    BadgeType["Warning"] = "warning";
    BadgeType["Success"] = "success";
    BadgeType["Info"] = "info";
    BadgeType["Violet"] = "violet";
    BadgeType["Reverse"] = "reverse";
})(BadgeType || (exports.BadgeType = BadgeType = {}));
const Badge = ({ children, value = null, type = BadgeType.Warning, empty, }) => ((0, jsx_runtime_1.jsxs)("div", { className: styles_module_css_1.default.root, children: [children, (value || empty) && ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(styles_module_css_1.default.badge, styles_module_css_1.default[type], { [styles_module_css_1.default.empty]: empty }), children: value }))] }));
exports.Badge = Badge;
exports.default = react_1.default.memo(exports.Badge);
